import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

const nombreSchema = yup
  .string()
  .required(DEFAULT_MESSAGES.REQUIRED)
  .test(
    "is-not-blank",
    "Este campo no puede estar vacío o contener solo espacios.",
    value => !!value && value.trim().length > 0 && /[A-Za-z0-9]/.test(value)
  );

const descripcionSchema = yup
  .string()
  .notRequired()
  .test(
    "valid-descripcion",
    "La descripción no puede estar vacía o contener solo espacios.",
    value => !value || (value.trim().length > 0 && /[A-Za-z0-9]/.test(value))
  );

export const createTitulosSchema = yup.object({
  nombre: nombreSchema,
  descripcion: descripcionSchema,
  nivel_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),
});
